var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 infinite-scroll-trigger"},[(_vm.isLoading && _vm.showSpinner)?_vm._t("default",function(){return [_c('div',{staticClass:"w-100 py-3 text-center"},[_c('b-spinner',{attrs:{"small":""}})],1)]}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d403cf7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/InfiniteScrollTrigger.vue
// module id = null
// module chunks = 